var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var HttpService = /** @class */ (function () {
    function HttpService() {
    }
    Object.defineProperty(HttpService.prototype, "request", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (config) {
            return __awaiter(this, void 0, void 0, function () {
                var response, error_1, _a;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetch(this.getUrl(config.url, config.qs), {
                                    method: config.method,
                                    headers: __assign(__assign({}, config.headers), { "Content-Type": "application/json" }),
                                    body: JSON.stringify(config.body),
                                })];
                        case 1:
                            response = _d.sent();
                            if (config.throwOnNot200 && (response.status >= 300 || response.status < 200)) {
                                throw new Error(JSON.stringify(response.body));
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _d.sent();
                            if (config.throwOnNot200) {
                                throw error_1;
                            }
                            response = {
                                status: 500,
                                text: function () { return Promise.resolve(error_1.message); },
                            };
                            return [3 /*break*/, 3];
                        case 3:
                            _d.trys.push([3, 5, , 7]);
                            _b = {
                                status: response.status
                            };
                            return [4 /*yield*/, response.clone().json()];
                        case 4: return [2 /*return*/, (_b.body = (_d.sent()),
                                _b)];
                        case 5:
                            _a = _d.sent();
                            _c = {
                                status: response.status
                            };
                            return [4 /*yield*/, response.text()];
                        case 6: return [2 /*return*/, (_c.body = (_d.sent()),
                                _c)];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(HttpService.prototype, "getUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url, qs) {
            if (!qs) {
                return url;
            }
            var queryString = Object.keys(qs)
                .map(function (key) { return "".concat(key, "=").concat(qs[key]); })
                .join("&");
            return "".concat(url, "?").concat(queryString);
        }
    });
    return HttpService;
}());
export { HttpService };
